import { apiPost, apiGet, apiDelete, apiPatch } from "./apiClient";
import { 
  LoginAccessTokenResponse, 
  Body_AccessToken as AccessToken,
  UserRegister,
  UserUpdateMe,
  UpdatePassword,
  NewPassword,
  Message
} from "../types/Auth";
import { User } from "../types/User";
import { APIKey, APIKeyCreate } from "../types/Api";

export const userLogin = async (data: AccessToken) => {
  return apiPost<LoginAccessTokenResponse>(`/login/access-token`, data, { formData: true });
};

export const me = async (): Promise<User> => {
  return apiGet<User>(`/users/me`, { requiresAuth: true });
};

export const registerUser = async (data: UserRegister): Promise<User> => {
  return apiPost<User>(`/users/signup`, data, { requiresAuth: false });
};

export const updateUserProfile = async (data: UserUpdateMe): Promise<User> => {
  return apiPatch<User>(`/users/me`, data, { requiresAuth: true });
};

export const updatePassword = async (data: UpdatePassword): Promise<Message> => {
  return apiPatch<Message>(`/users/me/password`, data, { requiresAuth: true });
};

export const requestPasswordReset = async (email: string): Promise<Message> => {
  return apiPost<Message>(`/password-recovery/${email}`, {}, { requiresAuth: false });
};

export const resetPassword = async (data: NewPassword): Promise<Message> => {
  return apiPost<Message>(`/reset-password/`, data, { requiresAuth: false });
};

export const createApiKey = async (data: APIKeyCreate): Promise<APIKey> => {
  return apiPost<APIKey>(`/api-keys`, data, { requiresAuth: true });
};

export const getApiKeys = async (): Promise<APIKey[]> => {
  return apiGet<APIKey[]>(`/api-keys`, { requiresAuth: true });
};

export const deleteApiKey = async (id: string): Promise<void> => {
  return apiDelete(`/api-keys/${id}`, { requiresAuth: true });
};

export const uploadAvatar = async (file: File): Promise<{ avatar_url: string; message: string }> => {
  const formData = new FormData();
  formData.append('file', file);
  return apiPost<{ avatar_url: string; message: string }>(`/upload/avatar`, formData, { requiresAuth: true });
};
